import Button, { ButtonProps } from 'atoms/Button/Button';
import Grid from 'atoms/Layout/Grid/Grid';
import Stack from 'atoms/Layout/Stack/Stack';
import { TypographyProps } from 'atoms/Typography/Typography';
import HeadingAndSupportingText from 'molecules/HeadingAndSupportingText/HeadingAndSupportingText';
import React from 'react';
import { ActionsContainer } from './CallToActionCardHorizontal.styles';

interface CallToActionCardHorizontalProps {
  headline: TypographyProps;
  description?: TypographyProps;
  actions: ButtonProps[];
}

const CallToActionCardHorizontal = ({
  headline,
  description,
  actions,
}: CallToActionCardHorizontalProps): JSX.Element => (
  <Grid
    totalColumns={1}
    padding='spacing-7xl'
    paddingSm={['spacing-5xl', 'spacing-3xl']}
    background='bg-primary-solid'
    borderRadius='radius-2xl'
    overflow='hidden'
  >
    <Stack
      gap='spacing-4xl'
      justify='space-between'
      align='flex-start'
      directionLg='column'
    >
      <HeadingAndSupportingText
        maxWidth='width-xl'
        heading={{
          color: 'text-primary-on-brand',
          textAlign: 'left',
          ...headline,
        }}
        supportingText={
          description && {
            color: 'text-tertiary-on-brand',
            textAlign: 'left',
            ...description,
          }
        }
        gap='spacing-2xl'
        gapSm='spacing-xl'
      />
      <ActionsContainer
        direction='row'
        gap='spacing-lg'
        directionSm='column'
      >
        {actions.map((action, index) => (
          <Stack key={index}>
            <Button {...action} />
          </Stack>
        ))}
      </ActionsContainer>
    </Stack>
  </Grid>
);

export default CallToActionCardHorizontal;
